<template>
	<v-menu v-model="menu" offset-y :nudge-top="hideDetails ? '' : '24'" :close-on-content-click="false" max-width="450">
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				v-model="areaText"
				@click:clear="textClear"
				readonly
				outlined
				placeholder="选择地区"
				dense
				clearable
				v-bind="attrs"
				v-on="on"
				:class="$attrs.styles ? '' : 'vtk-field'"
				:style="$attrs.styles"
				:hide-details="hideDetails"
				prepend-inner-icon="mdi-google-maps"></v-text-field>
		</template>
		<v-card elevation="0">
			<p class="pt-3 px-3">
				<v-icon color="primary" class="mr-1" size="20">mdi-map-marker-radius</v-icon>
				<span v-for="link in entity" :key="link.areaCode" class="link body-2 blue--text">{{ link.areaName }}</span>
			</p>
			<v-sheet class="rounded-lg mx-3" color="#b1b1b117">
				<v-tabs v-model="tab" @change="tabArea" class="pt-2 px-1">
					<v-tab v-for="(item, index) in tabItems" :key="index" class="mx-1" :style="tab == index && 'color:white;opacity:1'" :disabled="areaStorage.length <= index + 1" v-show="minArea ? minArea >= item.leve : true">{{ item.text }}</v-tab>
				</v-tabs>
				<v-sheet v-show="index == tab" v-for="(item, index) in tabItems" :key="index" class="px-3 py-1" min-height="100" color="rgba(0,0,0,0)">
					<v-chip-group v-model="current" active-class="chipActive" column>
						<v-chip v-for="area in areaItems" :key="area.id" @change="areaChange(area, index)" class="rounded" :class="area.areaCode == user.areacode && 'active'">
							{{ area.areaName }}
						</v-chip>
					</v-chip-group>
				</v-sheet>
			</v-sheet>

			<v-card-actions class="pr-0 py-3">
				<v-spacer />
				<v-btn @click="close" elevation="0" small><v-icon>mdi-progress-close</v-icon> 取消</v-btn>
				<v-btn @click="save" class="white--text mr-3" color="primary" elevation="0" small><v-icon>mdi-progress-check</v-icon> 确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	name: "VtkAreaTabs",
	props: {
		value: {
			type: [String, Object],
			default: null,
		},
		minArea: {
			type: Number,
			default: null,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		returnObject: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			menu: false,
			user: {},
			tab: 0,
			tabItems: [],
			areaStorage: [], //存储个级别地区数据
			areaItems: [], //当前选择地区的所有列
			entity: [], //存储选中的数据
			current: null, //回显值选中
			itemValue: "", //传值：最终选择值
			itemText: "", //传值：最终选择值
			areaText: "", //最终选择值
		};
	},
	watch: {
		value(newVal, oldVal) {
			if (newVal && newVal != oldVal) {
				this.view(newVal);
			}
		},
	},
	created() {
		this.user = this.$vtk.storage.get("_wit_acis_users");
		this.getAreaName(this.$attrs.fixed ? this.user.uniAreaCode.slice(0, this.$attrs.fixed) : this.user.uniAreaCode);
		this.value && this.view(this.value);
	},
	methods: {
		// 值回显
		view(code) {
			if (code && typeof code != "object") {
				this.$vtk.request.getForm(`dict/area/show/${code}`).then((res) => {
					let province = res.data.province ? `${res.data.province}` : "";
					let city = res.data.city ? `/${res.data.city}` : "";
					let district = res.data.district ? `/${res.data.district}` : "";
					let town = res.data.town ? `/${res.data.town}` : "";
					let village = res.data.village ? `/${res.data.village}` : "";
					this.areaText = `${province}${city}${district}${town}${village}`;
				});
			}
		},
		// 切换Tab地区级别
		tabArea(index) {
			this.areaItems = [...this.areaStorage[index]];
			if (index < this.entity.length) {
				this.current = this.areaItems.findIndex((e) => e.areaCode == this.entity[index].areaCode);
			} else {
				this.current = null;
			}
		},
		//选择地区
		areaChange(item, index) {
			this.entity = this.entity.slice(0, index);
			this.entity.push(item);
			this.areaStorage = this.areaStorage.slice(0, index + 1);
			if (this.tabItems.length > this.tab + 1 && (this.minArea ? this.minArea > item.areaCode.length : true)) {
				this.getTree(item.areaCode);
				this.tab++;
			}
		},
		// 加载下级地区
		getTree(code) {
			this.$vtk.request.getForm(`dict/area/next/${code}`).then((res) => {
				this.areaItems = res.data;
				this.areaStorage.push(res.data);
				this.current = null;
				this.$forceUpdate(); //强制刷新
			});
		},
		// 加载第一个地区，用户所在地区
		getAreaName(code) {
			if (code) {
				let leve = this.$attrs.fixed || this.user.uniAreaCode.length;
				this.entity = [];
				this.tabItems = [
					{ text: "省级", leve: "2" },
					{ text: "市级", leve: "4" },
					{ text: "区县", leve: "6" },
					{ text: "街镇", leve: "9" },
					{ text: "村社", leve: "12" },
				].filter((e) => e.leve >= leve);
				this.areaStorage = [];
				this.$vtk.request.getForm(`dict/area/show/${code}`).then((res) => {
					this.areaItems = [{ areaName: res.data.areaName, areaCode: res.data.areaCode }];
					this.areaStorage.push(this.areaItems);
					this.entity.push(this.areaItems[0]);
				});
			}
		},
		//确认保存
		save() {
			// this.itemText = "";
			// this.itemValue = "";
			let text = [];
			let val = [];
			this.entity.forEach((e) => {
				text.push(e.areaName);
				val.push(e.areaCode);
				this.itemText = e.areaName;
				this.itemValue = e.areaCode;
			});
			this.areaText = text.join().replace(/,/g, "/");
			// this.itemValue = value.join();
			this.returnObject ? this.$emit("input", { text: this.itemText, value: this.itemValue }) : this.$emit("input", this.itemValue);
			this.$emit("change");
			this.close();
		},

		// 清空
		textClear() {
			this.tab = 0;
			this.getAreaName(this.$attrs.fixed ? this.user.uniAreaCode.slice(0, this.$attrs.fixed) : this.user.uniAreaCode);
			// this.itemValue = this.user.areacode;
			this.$emit("input");
			this.$emit("change");
		},
		// 关闭弹窗
		close() {
			this.menu = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.link::after {
	content: " / ";
	font-size: 14px;
	color: #999;
}
.link:last-of-type::after {
	content: "";
}
::v-deep .theme--dark.v-chip:not(.v-chip--active),
::v-deep .theme--light.v-chip:not(.v-chip--active) {
	background: #e0e0e000;
}
::v-deep .v-tabs-bar__content {
	background: #b1b1b117;
}
::v-deep .v-tabs-slider-wrapper {
	height: 32px !important;
	min-width: 90px !important;
}
::v-deep .v-tabs-slider {
	height: 32px;
	border-radius: 4px;
}
::v-deep .v-tabs-bar .v-tab {
	color: white;
	z-index: 9;
}
.tabActive {
	color: #fff;
}
::v-deep .v-tabs-bar {
	height: 32px;
}
.chipActive {
	color: #0095ff !important;
	background-color: #008eff05 !important;
}
.active {
	color: #0095ff !important;
	background-color: #008eff20 !important;
}
::v-deep .v-slide-group__next,
::v-deep .v-slide-group__prev {
	display: none;
}
</style>
